import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { createContext, useContext } from 'react';
import type { To } from 'react-router';

type Action = {
  onClick?: () => void;
  to?: To;
  label: ReactNode;
};

type PrimaryBuyActions = {
  primary?: Action;
  secondary?: Action;
};

export type PrimaryBuyConfirmationOptions = {
  actions?: PrimaryBuyActions;
  hideSecondaryOrTickets?: boolean;
};

export type BuyConfirmationProviderStateProps = {
  tokenOfferId?: string;
  onClose?: () => void;
  beforeOnClose?: () => void;
  primaryBuyId?: string;
  primaryBuyConfirmationOptions?: PrimaryBuyConfirmationOptions;
};

interface BuyConfirmationContext {
  showBuyingConfirmation: boolean;
  setBuyConfirmationProps: Dispatch<
    SetStateAction<BuyConfirmationProviderStateProps | null>
  >;
  setShowBuyingConfirmation: (bool: boolean) => void;
  buyConfirmationProps: BuyConfirmationProviderStateProps | null;
}

const buyConfirmationContext = createContext<BuyConfirmationContext | null>(
  null
);

export const useBuyConfirmationContext = () =>
  useContext(buyConfirmationContext)!;

export const BuyConfirmationProvider = buyConfirmationContext.Provider;
